<template>
  <v-sheet>
    <v-container class="">
      <v-row align="center" justify="center">
        <v-col cols="12" md="8" lg="8" sm="12">
          <v-img :src="ImgBlockchain" height="70" width="70"></v-img>
          <h1>{{ $t('specialty.title') }}</h1>
          <h1>{{ $t('specialty.subtitle') }}</h1>
          <p style="font-size: 18px">
            {{ $t('specialty.p') }}
          </p>
          <p style="font-size: 18px">
            {{ $t('specialty.paragraph') }}
          </p>
        </v-col>
        <v-col cols="12" md="4" lg="4" sm="12">
          <v-img :src="Produtos" alt=""> </v-img>
        </v-col>
      </v-row>
      <v-row class="d-flex">
        <v-card
          v-for="(item, i) in $t('landing.products')"
          :key="i"
          :class="$vuetify.breakpoint.mdAndUp ? 'col-4' : 'col-12'"
          outlined
          style="margin-left: auto; margin-right: auto; margin-bottom: 10px; text-align: center; border-color: white;"
        >
          <v-img
            height="70px"
            width="70px"
            :src="obj[i].img"
            alt=""
            style="margin-left: auto; margin-right: auto;"
          >
          </v-img>
          <h3>{{ item.title }}</h3>
          <p :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 15px' : 'font-size: 18px'">
            {{ item.subtitle }}
          </p>
        </v-card>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import Produtos from 'Assets/Produtos/produtos.png';
import ImgBlockchain from 'Assets/Landing/blockchain2.png';
import TokenizacaoDeAtivos from 'Assets/QuemSomos/TokenizacaoDeAtivos.png';
import RegistroDeDocumentos from 'Assets/QuemSomos/RegistroDeDocumentos.png';
export default {
  name: 'Specialty',
  data() {
    return {
      Produtos,
      ImgBlockchain,
      obj: [
        {
          img: TokenizacaoDeAtivos,
        },
        {
          img: RegistroDeDocumentos,
        },
      ],
    };
  },
  components: {},
};
</script>
<style>
#waveButton {
  position: relative;
  height: 90px;
  width: '100%';
  background: #001e4a;
}
#waveButton:after {
  content: '';
  display: block;
  border-radius: 0% 0% 100% 100%;
  width: '120%';
  height: 80px;
  background-color: white;
  right: -5px;
  transform: rotate(0deg);
}
</style>
